// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"54":"9a83c114","225":"b50a2ccb","413":"cd524e05","560":"a0458be3","696":"20c06844","727":"5194a733","810":"859d6356"}[chunkId] + ".css";
};